<template>
  <section>
    <v-container fluid>
      <v-row class="justify-end align-center">
        <v-col cols="auto">
          <v-btn @click="openFormDialog" class="accent shadow-4 px-8" color="success" large rounded>
            Crear Contacto
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="openImportDialog" v-bind="attrs" v-on="on" color="info" small rounded fab>
                <v-icon>
                  mdi-upload
                </v-icon>
              </v-btn>
            </template>
            <span>Importar</span>
          </v-tooltip>
        </v-col>
        <v-col cols="auto" class="ml-auto">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="downloadTodayCsv()" color="success" v-bind="attrs" v-on="on" small rounded fab>
                <v-icon>
                  mdi-download
                </v-icon>
              </v-btn>
            </template>
            <span>Exportar</span>
          </v-tooltip>
        </v-col>

        <v-col cols="12" md="5">
          <v-row dense justify="center" align="center">
            <v-col cols="4">
              <v-select
                v-model="searchType"
                required
                filled
                rounded
                dense
                single-line
                hide-details
                :items="SearchTypeList"
                item-text="label"
                item-value="id"
                label="Tipo"
              ></v-select>
            </v-col>

            <v-col cols="8">
              <v-text-field
                filled
                rounded
                dense
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="shadow-1 mt-5 mt-md-10">
      <v-data-table
        sort-by="created_at"
        :sort-desc="false"
        show-expand
        single-expand
        :search="search"
        :headers="headers"
        :items="contactsList"
        item-key="id"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalItems"
        no-data-text="No hay contactos que mostrar"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <!-- <template v-slot:[`item.name`]="{ item }">
          {{ `${item.name} ${item.lastNAme}` }}
        </template> -->

        <template v-slot:[`item.name`]="{ item }">
          <v-list two-line dense max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="px-0">
                <v-list-item-title class="primary--text text--darken-1 font-weight-medium">
                  {{ item.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              v-if="item.whatsapp"
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="toggleQuickMsgDialog(item.whatsapp)"
            >
              <v-icon>mdi-whatsapp</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'accent' : 'blue-grey'" @click.stop="handleEdit(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>

          <!-- <v-hover v-slot:default="{ hover }">
            <v-tooltip color="blue-grey" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="handleCallDialog(item)"
                  v-on="on"
                  text
                  icon
                  :color="hover ? 'error' : 'blue-grey'"
                >
                  <v-icon>mdi-phone</v-icon>
                </v-btn>
              </template>
              <span>Llamar</span>
            </v-tooltip>
          </v-hover> -->

          <v-hover v-slot:default="{ hover }">
            <v-btn text icon :color="hover ? 'error' : 'blue-grey'" @click.stop="handleDelete(item)">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="text--secondary">
            <v-col cols="4" class="py-0">
              <p class="info--text">
                Tipo:
                <span class="text--primary">{{ item.type }}</span>
              </p>
            </v-col>
            <v-col cols="4" class="py-0">
              <p class="info--text">
                Comentario:
                <span class="text--primary">
                  {{ item.comments }}
                </span>
              </p>
            </v-col>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <!-- Form dialog -->
    <contact-form
      v-if="isOpenForm"
      :isActive="isOpenForm"
      :isEditMode="isEditMode"
      :dataToEdit="contactToEdit"
      @close:dialog="closeFormDialog"
    ></contact-form>
    
    <!-- Import Dialog -->
    <import-dialog
      :isOpenDialog="isOpenImport"
      @dialog:close="isOpenImport = false"
    ></import-dialog>
    
    <!-- Delete Dialog -->
    <delete-dialog
      v-if="isOpenDelete"
      :isActive="isOpenDelete"
      :id="contactToDelete.id"
      @dialog:close="closeDeleteDialog"
    ></delete-dialog>

    <!-- New WhatsApp chat -->
    <quick-message-dialog
      v-if="isOpenQuickMsgDialog"
      :isActive="isOpenQuickMsgDialog"
      :agent="userName"
      :number="whatsappNumber"
      :module="'contacts'"
      @dialog:close="toggleQuickMsgDialog"
    ></quick-message-dialog>

    <!-- <newTicketDialog
      v-if="newTicketDialog"
      :isActive="newTicketDialog"
      :data="newChatData"
      @dialog:close="closeNewTicketDialog"
    ></newTicketDialog> -->
  </section>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import QuickMessageDialog from "@/components/chats/QuickMessageDialog.vue";
// import newTicketDialog from "@/components/chats/newTicketDialog.vue";
import ContactForm from "@/components/ContactSettings/ContactForm.vue";
import ImportDialog from "@/components/ContactSettings/ImportDialog.vue";
import DeleteDialog from "@/components/ContactSettings/DeleteDialog.vue";
import CdrDownloadToCsv from "@/components/Utils/CdrDownloadCsv";
import { mapState } from "vuex";

export default {
  name: "ContactList",

  components: {
    ContactForm,
    ImportDialog,
    DeleteDialog,
    // newTicketDialog,
    QuickMessageDialog
  },

  data() {
    return {
      isLoading: false,
      isOpenForm: false,
      isEditMode: false,
      isOpenDelete: false,
      isOpenImport: false,
      isOpenQuickMsgDialog: false,
      // newTicketDialog: false,
      whatsappNumber: "",
      search: "",
      // For pagination
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      // End for pagination
      contactsList: [],
      contactToEdit: {},
      contactToCall: {},
      contactToDelete: {},
      headers: [
        {
          text: "Nombre",
          align: "left",
          value: "name",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Teléfono 1",
          value: "phone1",
          class: "primary--text",
          width: "10%",
        },
        {
          text: "Teléfono 2",
          value: "phone2",
          class: "primary--text",
          width: "10%",
        },
        {
          text: "WhatsApp",
          value: "whatsapp",
          class: "primary--text",
          width: "10%",
        },
        {
          text: "Empresa",
          value: "business",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Agente",
          value: "agent_contacts.name",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "15%",
          align: "right",
          sortable: false,
        },
        { text: "", value: "data-table-expand" },
      ],
      SearchTypeList: [
        { id: "all", label: "Todos" },
        { id: "name", label: "Nombre" },
        { id: "phone", label: "Teléfono" },
        { id: "type", label: "Tipo" },
        // "Documento"
      ],
      searchType: "",
    };
  },

  watch: {
    options: {
      handler() {
        this.getContacts();
      },
      deep: true,
    },

    search() {
      this.getContacts();
    },
  },

  computed:{
    ...mapState({
      userName: (state) => state.passport.user.name,
    }),
  },

  methods: {
    /**
     * Alterna el estado de visibilidad del diálogo de mensaje rápido.
     */
    toggleQuickMsgDialog(number) {
      this.isOpenQuickMsgDialog = !this.isOpenQuickMsgDialog;
      this.whatsappNumber = number || "";
    },

    /**
     * Obtiene la lista de contactos desde el servidor según los filtros y opciones de paginación actuales.
     * Actualiza la lista de contactos y el total de elementos. Muestra un mensaje de error si la solicitud falla.
     * 
     * @async
     * @returns {Promise<void>}
     */
    async getContacts() {
      const page = this.options.page || 1;
      const itemPerPage = this.options.itemsPerPage || 15;
      this.isLoading = true;
      try {
        const { data } = await PbxHttpClient.get(`/admin/contacts`, {
          params: {
            page,
            itemPerPage,
            type: this.searchType,
            value: this.search,
          },
        });
        this.totalItems = data.total;
        this.contactsList = data.data;
      } catch (err) {
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
      finally {
        this.isLoading = false;
      }
    },

    /**
     * Prepara los datos necesarios para iniciar un nuevo chat.
     * Asigna el ID y si es un grupo, luego abre el diálogo para crear el ticket.
     * 
     * @param {Object} item - Objeto que representa el contacto o grupo seleccionado.
     * @param {boolean} item.isGroup - Indica si el chat es de grupo.
     * @param {number|string} item.id - ID del contacto o grupo.
     */
    handleChat(item) {
      this.newChatData = {
        isGroup: item.isGroup,
        id: item.id,
      };
      
      this.newTicketDialog = true;
    },

    /**
     * Cierra el diálogo de nuevo ticket.
     * Si se recibe un valor verdadero, redirige al chat correspondiente usando el ID del nuevo chat.
     * 
     * @param {boolean} value - Indica si se debe redirigir al chat tras cerrar el diálogo.
     */
    closeNewTicketDialog(value) {
      this.newTicketDialog = false;

      if (value)
        this.$router.push({
          name: "Chats",
          params: { id: this.newChatData.id },
        });
    },

    /**
     * Activa el modo edición para un contacto específico y abre el formulario de edición.
     * 
     * @param {Object} item - El contacto que se desea editar.
     */
    handleEdit(item) {
      this.isEditMode = true;
      this.contactToEdit = item;
      this.openFormDialog();
    },

    /**
     * Establece el contacto a eliminar y abre el diálogo de confirmación de eliminación.
     * 
     * @param {Object} item - El contacto que se desea eliminar.
     */
    handleDelete(item) {
      this.contactToDelete = item;
      this.isOpenDelete = true;
    },

    /**
     * Abre el diálogo del formulario para crear o editar un contacto.
     */
    openFormDialog() {
      this.isOpenForm = true;
    },

    /**
     * Abre el diálogo para importar contactos desde un archivo.
     */
    openImportDialog() {
      this.isOpenImport = true;
    },

    closeFormDialog(data = false) {
      if (data && this.isEditMode) this.contactsList = this.contactsList.map((el) => (el.id === data.id ? data : el));
      if (data && !this.isEditMode) this.contactsList = [...this.contactsList, data];
      this.isOpenForm = false;
      this.isEditMode = false;
      this.contactToEdit = {};
    },

    closeDeleteDialog(id = false) {
      if (id) this.contactsList = this.contactsList.filter((el) => el.id !== id);
      this.isOpenDelete = false;
    },
    async downloadTodayCsv() {
      const payload = { date: "18/07/22" };
      try {
        await CdrDownloadToCsv(payload, "contacts");
      } catch (err) {
        // console.log(err);
        this.$snotify.error("No se pudo descargar los registros seleccionados.", "¡Error!");
      }
    },
  },
};
</script>
<style>
.phone-field input::-webkit-outer-spin-button,
.phone-field input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.phone-field input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>
